import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { motion, AnimatePresence } from 'framer-motion'
import styles from './Home.module.css'
import { BASE_URL_API } from '../References/Urls'
import { toast } from 'react-toastify'
import { CgSpinnerAlt } from "react-icons/cg";

const Home = () => {
    const { eventIdentifier } = useParams()
    const [appointment, setAppointment] = useState({ clientName: 'Navneet Chandan', service: '', date: '' })
    const [loading, setLoading] = useState(false)
    const [actionStatus, setActionStatus] = useState(null)
    const [remarks, setRemarks] = useState('')
    const [showRemarkBox, setShowRemarkBox] = useState(false)
    const [isCancelling, setIsCancelling] = useState(false)
    const [isAccepting, setIsAccepting] = useState(false)

    const getEventData = async () => {
        setLoading(true)
        const response = await fetch(BASE_URL_API + "/getEventData",
            {
                method: "POST",
                body: JSON.stringify({
                    eventIdentifier: eventIdentifier
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo.status === "success") {
                setAppointment(respo?.response)
            } else {

            }
            console.log(respo)
        }
        setLoading(false)
    }

    useEffect(() => {
        getEventData()
    }, [])

    // Handle back button for modal close
    useEffect(() => {
        const handlePopState = () => {
            setShowRemarkBox(false)
        }

        if (showRemarkBox) {
            window.history.pushState({ modalOpen: true }, '') // Push state
            window.addEventListener('popstate', handlePopState)
        }

        return () => {
            window.removeEventListener('popstate', handlePopState)
        }
    }, [showRemarkBox])

    const handleAccept = async () => {
        if (window.confirm("Are you sure, you want to accept?")) {
            setIsAccepting(true)
            const response = await fetch(BASE_URL_API + "/acceptAppointment",
                {
                    method: "POST",
                    body: JSON.stringify({
                        eventIdentifier: eventIdentifier
                    })
                });

            if (!response.ok) {
                console.log("Something went wrong : Server Error")
            } else {
                const respo = await response.json()
                if (respo.status === "success") {
                    toast(`Successfully accepted!`)
                    getEventData()
                } else {

                }
                console.log(respo)
            }
            setIsAccepting(false)
        }
    }

    const convertTo12Hour = (time24) => {
        if (!time24 || typeof time24 !== 'string') return 'Invalid time';

        const parts = time24.split(':');
        if (parts.length < 2) return 'Invalid time';

        const [hoursStr, minutes] = parts;
        const hours = parseInt(hoursStr, 10);
        const mins = parseInt(minutes, 10);

        if (isNaN(hours) || isNaN(mins) || hours < 0 || hours > 23 || mins < 0 || mins > 59) {
            return 'Invalid time';
        }

        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHour = hours % 12 || 12;
        const formattedMinutes = String(mins).padStart(2, '0');

        return `${formattedHour}:${formattedMinutes} ${ampm}`;
    };

    const getWeekdayFromDate = (dateStr) => {
        if (!dateStr || typeof dateStr !== 'string') return 'Invalid date';

        const date = new Date(dateStr);

        // Check for invalid date
        if (isNaN(date.getTime())) return 'Invalid date';

        const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return weekdays[date.getDay()];
    };

    const handleCancel = async () => {
        if (!remarks.trim()) return alert('Please enter cancellation remarks.')
        setIsCancelling(true)
        const response = await fetch(BASE_URL_API + "/cancelAppointment",
            {
                method: "POST",
                body: JSON.stringify({
                    eventIdentifier: eventIdentifier,
                    remarks: remarks
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo.status === "success") {
                toast(`Successfully cancelled!`)
                getEventData()
            } else {

            }
            console.log(respo)
        }
        setIsCancelling(true)
    }


    if (loading) return <div className={styles.loading}>Loading...</div>

    if (appointment?.currentStatus === 'ACCEPTED') {
        return (
            <div className={styles.container}>
                <div className={styles.mainContainer}>
                    <div className={styles.userIconWrapper}>
                        <div className={styles.userIcon}>
                            <img src="https://cdn-icons-png.flaticon.com/512/149/149071.png" />
                        </div>
                        <div className={styles.clientName}>
                            {appointment?.clientName}
                        </div>
                    </div>
                    <div className={styles.headingWrapper}>
                        <div>
                            <div className={styles.dateTitle}>Date</div>
                            <div className={styles.start}>
                                <div>
                                    {appointment?.start?.substr(0, 10)}
                                </div>
                                <div>
                                    {getWeekdayFromDate(appointment?.start?.substr(0, 10))}
                                </div>
                            </div>
                            <div className={styles.start}>
                                {convertTo12Hour(appointment?.start?.substr(10, 10))}
                            </div>
                        </div>
                    </div>
                    <div className={styles.cancelledIcon}>
                        ✅
                    </div>
                    <div className={styles.headingAccepted}>Appointment Accepted!</div>
                    <div className={styles.cardWrapper}>
                        <div className={styles.card}>
                            <div className={styles.eachSectionTitle}>
                                <div className={styles.estTitle} >Service(s)</div>
                                <div className={styles.servicesNotes}>
                                    {appointment?.servicesNotes}
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className={styles.remarks}>
                                {appointment?.remarks}
                            </div>
                        </div>
                        <div>
                            {appointment?.hasCancelledByStaff === "1" &&
                                <div className={styles.cancellationRemarks}>
                                    {appointment?.staffCancellationRemarks}
                                </div>
                            }
                        </div>
                    </div>

                </div>
                <AnimatePresence>
                    {showRemarkBox && (
                        <motion.div
                            className={styles.cancelBoxWrapper}
                            initial={{ y: "100%" }}
                            animate={{ y: 0 }}
                            exit={{ y: "100%" }}
                            // transition={{ type: "spring", damping: 20, stiffness: 200 }}
                            transition={{ type: "tween", duration: 0.20, ease: "easeInOut" }}

                        >
                            <div className={styles.cancelBoxContainer}>
                                <div className={styles.cancelBox}>
                                    <div className={styles.cancelOption}>
                                        <textarea
                                            value={remarks}
                                            onChange={(e) => setRemarks(e.target.value)}
                                            placeholder="Enter cancellation reason"
                                            className={styles.remarksInput}
                                        />
                                        <div className={styles.actionBtn}>
                                            <button onClick={handleCancel} className={styles.submitCancelBtn}>Submit Cancellation</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    )}
                </AnimatePresence>

                <div className={styles.actionWrapper}>
                    <div className={styles.actionContainer}>
                        {isAccepting === true ?
                            <div className={styles.buttonGroup}>
                                <button disabled className={styles.cancelBtn}>Cancel</button>
                                <button disabled className={styles.acceptBtn}>
                                    <CgSpinnerAlt size={20} className={styles.spinner} /> Accepting...
                                </button>
                            </div>
                            :
                            <div className={styles.buttonGroup}>
                                <button onClick={() => setShowRemarkBox(true)} className={styles.cancelBtn}>Cancel</button>
                                <button onClick={handleAccept} className={styles.acceptBtn}>Accept</button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }

    if (appointment?.currentStatus === 'CANCELLED') {
        return (
            <div className={styles.container}>
                <div className={styles.mainContainer}>
                    <div className={styles.userIconWrapper}>
                        <div className={styles.userIcon}>
                            <img src="https://cdn-icons-png.flaticon.com/512/149/149071.png" />
                        </div>
                        <div className={styles.clientName}>
                            {appointment?.clientName}
                        </div>
                    </div>
                    <div className={styles.headingWrapper}>
                        <div>
                            <div className={styles.dateTitle}>Date</div>
                            <div className={styles.start}>
                                <div>
                                    {appointment?.start?.substr(0, 10)}
                                </div>
                                <div>
                                    {getWeekdayFromDate(appointment?.start?.substr(0, 10))}
                                </div>
                            </div>
                            <div className={styles.start}>
                                {convertTo12Hour(appointment?.start?.substr(10, 10))}
                            </div>
                        </div>
                    </div>
                    <div className={styles.cancelledIcon}>
                        ❌
                    </div>
                    <div className={styles.headingCancelled}>Appointment Cancelled</div>
                    <div className={styles.cardWrapper}>
                        <div className={styles.card}>
                            <div className={styles.eachSectionTitle}>
                                <div className={styles.estTitle} >Service(s)</div>
                                <div className={styles.servicesNotes}>
                                    {appointment?.servicesNotes}
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className={styles.remarks}>
                                {appointment?.remarks}
                            </div>
                        </div>
                        <div>
                            {appointment?.hasCancelledByStaff === "1" &&
                                <div className={styles.cancellationRemarks}>
                                    {appointment?.staffCancellationRemarks}
                                </div>
                            }
                        </div>
                    </div>
                </div>

            </div>
        )
    }

    return (
        <div className={styles.container}>
            <div className={styles.mainContainer}>
                <div className={styles.userIconWrapper}>
                    <div className={styles.userIcon}>
                        <img src="https://cdn-icons-png.flaticon.com/512/149/149071.png" />
                    </div>
                    <div className={styles.clientName}>
                        {appointment?.clientName}
                    </div>
                </div>
                <div className={styles.headingWrapper}>
                    <div className={styles.heading}>New Appointment Request</div>
                    <div>
                        <div className={styles.dateTitle}>Date</div>
                        <div className={styles.start}>
                            <div>
                                {appointment?.start?.substr(0, 10)}
                            </div>
                            <div>
                                {getWeekdayFromDate(appointment?.start?.substr(0, 10))}
                            </div>
                        </div>
                        <div className={styles.start}>
                            {convertTo12Hour(appointment?.start?.substr(10, 10))}
                        </div>
                    </div>
                </div>
                <div className={styles.cardWrapper}>

                    <div className={styles.card}>
                        <div className={styles.eachSectionTitle}>
                            <div className={styles.estTitle} >Service(s)</div>
                            <div className={styles.servicesNotes}>
                                {appointment?.servicesNotes}
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className={styles.remarks}>
                            {appointment?.remarks}
                        </div>
                    </div>
                </div>
            </div>

            <AnimatePresence>
                {showRemarkBox && (
                    <motion.div
                        className={styles.cancelBoxWrapper}
                        initial={{ y: "100%" }}
                        animate={{ y: 0 }}
                        exit={{ y: "100%" }}
                        // transition={{ type: "spring", damping: 20, stiffness: 200 }}
                        transition={{ type: "tween", duration: 0.20, ease: "easeInOut" }}

                    >
                        <div className={styles.cancelBoxContainer}>
                            <div className={styles.cancelBox}>
                                <div className={styles.cancelOption}>
                                    <textarea
                                        value={remarks}
                                        onChange={(e) => setRemarks(e.target.value)}
                                        placeholder="Enter cancellation reason"
                                        className={styles.remarksInput}
                                    />
                                    <div className={styles.actionBtn}>
                                        {isCancelling === true ?
                                            <button disabled className={styles.submitCancelBtn}>
                                                <CgSpinnerAlt size={20} className={styles.spinner} />Cancellating ...
                                            </button>
                                            :
                                            <button onClick={handleCancel} className={styles.submitCancelBtn}>Submit Cancellation</button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>

            <div className={styles.actionWrapper}>
                <div className={styles.actionContainer}>
                    {isAccepting === true ?
                        <div className={styles.buttonGroup}>
                            <button disabled className={styles.cancelBtn}>Cancel</button>
                            <button disabled className={styles.acceptBtn}>
                                <CgSpinnerAlt size={20} className={styles.spinner} /> Accepting...
                            </button>
                        </div>
                        :
                        <div className={styles.buttonGroup}>
                            <button onClick={() => setShowRemarkBox(true)} className={styles.cancelBtn}>Cancel</button>
                            <button onClick={handleAccept} className={styles.acceptBtn}>Accept</button>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default Home
